import { getGroupPermissionFactory, PermissionEnum } from '../../../../common';
import { getLocationManagementModuleName } from './location-management.permissions';

export class CountriesPermissions {
    static GroupName = `${getLocationManagementModuleName()}.Countries`;

    static getPermissions = getGroupPermissionFactory(CountriesPermissions.GroupName);

    static Permissions = {
        Create: CountriesPermissions.getPermissions(PermissionEnum.CREATE),
        Read: CountriesPermissions.getPermissions(PermissionEnum.READ),
        ReadAll: CountriesPermissions.getPermissions(PermissionEnum.READ_ALL),
        Update: CountriesPermissions.getPermissions(PermissionEnum.UPDATE)
    };
}
